import { render, staticRenderFns } from "./IconEditionModal.vue?vue&type=template&id=4273db87&scoped=true&"
import script from "./IconEditionModal.vue?vue&type=script&lang=js&"
export * from "./IconEditionModal.vue?vue&type=script&lang=js&"
import style0 from "./IconEditionModal.vue?vue&type=style&index=0&id=4273db87&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4273db87",
  null
  
)

export default component.exports